import { BROADCAST_SET_MIXER_ATTENDEE } from '../Types';

function setMixerAttendee(attendeeId) {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_MIXER_ATTENDEE,
      payload: attendeeId
    };

    dispatch(action);
  };
}

export default setMixerAttendee;
